module.exports = __webpack_public_path__ + "static/media/text-allign-left.1402118d.svg";